import React, { useEffect, useLayoutEffect, useState } from "react";

import { Col, FormGroup, Label, Row } from "reactstrap";
import { generateInputTag, getInputSizing } from "components/DynamicForm/utils";
import inputsConfig from "./inputsConfig";
import CRProvincesData from "utils/CRProvincesData";


const AddressSelectInput = (props) => {
  const { id, name = "address", value, onChange, formik } = props
  const [address, setAddress] = useState({});
  const [inputs, setInputsData] = useState({});

  useEffect(() => {
    if (value) {
      preloadAddressInfo(value);
    }
  }, [value]);

  useLayoutEffect(() => {
    setSelectData(address);
  }, [address]);

  const preloadAddressInfo = (value) => {
    setAddress(value);
  }

  const setInputValue = (name, value, setInputValue) => {
    let newAddress = {
      ...address,
      [name]: value
    };
    if (name == inputs.province.name) {
      newAddress[inputs.canton.name] = "";
      newAddress[inputs.district.name] = "";
    }
    if (name == inputs.canton.name) {
      newAddress[inputs.district.name] = "";
    }
    setAddress(newAddress);
    triggerOnChange(newAddress);

  }

  const triggerOnChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  }

  const setSelectData = (address) => {
    const inputs = { ...inputsConfig };
    inputs.province = {
      ...inputs.province,
      name: `${name}_${inputs.province.name}`
    };
    inputs.canton = {
      ...inputs.canton,
      name: `${name}_${inputs.canton.name}`
    };
    inputs.district = {
      ...inputs.district,
      name: `${name}_${inputs.district.name}`
    };

    const provinceId = address[inputs.province.name]
    if (provinceId) {
      const cantones = CRProvincesData[provinceId].cantones;
      inputs.canton.options = Object.keys(cantones).reduce((a, key) => {
        return {
          ...a,
          [key]: cantones[key].name
        }
      }, {});
    }
    const cantonId = address[inputs.canton.name]
    if (cantonId) {
      inputs.district.options = CRProvincesData[provinceId].cantones[cantonId].distritos;
    }

    setInputsData(inputs);
  }

  const generateAddressInputTag = (inputId, inputConfig, label) => {
    const sizing = getInputSizing(inputConfig.sizing);
    return (
      <Col {...sizing}>
        <FormGroup>
          <Label for={inputId}>{label}</Label>
          {generateInputTag(inputId, inputConfig, address, (name, value, dataType) => setInputValue(name, value, dataType), formik)}
        </FormGroup>
      </Col>
    );
  }

  return (
    <>
      {inputs.province &&
        (
          <Row>
            {generateAddressInputTag(`${id}-province`, inputs.province, "Provincia")}
            {generateAddressInputTag(`${id}-canton`, inputs.canton, "Canton")}
            {generateAddressInputTag(`${id}-district`, inputs.district, "Districto")}
          </Row>
        )
      }
    </>
  );
}

export default AddressSelectInput;